import { LicenseCategory } from '../types/license';

export const LICENSE_CATEGORIES: readonly LicenseCategory[] = [
  'Office 365',
  'Microsoft 365 Business',
  'Microsoft 365 Enterprise',
  'Microsoft 365 Frontline',
  'Microsoft 365 Education',
  'Microsoft 365 Government'
] as const;